module.exports = __webpack_public_path__ + "img/SinkSDD_Gray_1280x1010.fd630ff4.jpg";